import { PubSubService } from './../service/pubSub.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, OnDestroy } from '@angular/core'
import { wicService } from '../services/wic/wic.service';
import { SystemService } from '../service/system.service';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
  selector: 'bh-walkincenter',
  templateUrl: './walkincenter.template.html'
})

export class walkincenterComponent implements OnInit, OnDestroy {
  public doughnutChartLabels: string[] = [];
  public doughnutChartData: number[] = [];
  public doughnutChartColors: any[] = [];
  selectedOption = 'overAll';
  device = null;
  platform;
systemService = new SystemService();
  options =
  {
    "animation": {
      "duration": 0
    },
    "title": {
      "display": true,
      "text": "AVERAGE WAITING TIME",
      "fontSize": 16,
      "position": "top"
    },
    "legend": {
      "display": true,
      "position": "bottom"
    },
    "tooltips": {
      "callbacks": {},
      "bodyFontSize": 10,
      "displayColors": false
    },
    pieceLabel: {
      render: 'percentage',
      arc: true,
      fontSize: 14,
      fontStyle: 'bold',
      fontColor: '#000',
      position: 'border'
    },
    segmentShowStroke: true,
    segmentStrokeColor: "#fff",
    segmentStrokeWidth: 2,
    percentageInnerCutout: 50,
    responsive: true,
    maintainAspectRatio: true,
    showScale: true,
    circumference: Math.PI,
    rotation: -1 * Math.PI
  }

  dataObject: any = {};

  wicData: any = {};
  getDataSub: any;

  constructor(private wicS: wicService, private pubsub: PubSubService) { }

  ngOnInit() {
    this.checkMedia();
    this.getDataSub = this.pubsub.$sub('getData', (eventObject) => {
      this.getWicData();
    });
    this.getWicData();
    if(window.navigator.userAgent.indexOf('iPhone') > -1){
      this.device = 'ios';
    }
  }

  getWicData(selectedOption?: string) {
    this.wicS.getWicData().then(result => {
      if (result[0]) {
        this.dataObject = result[0];
        if (selectedOption) {
          this.selectedOption = selectedOption;
        }
        this.wicData = this.dataObject[this.selectedOption];
      }
    })
  }

  checkMedia() {
    if (window.matchMedia('(max-width: 599px)').matches) {
      this.options.legend.position = 'top';
    }
  }

  ngOnDestroy() {
    this.getDataSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/walkincenterComponent/walkincenter.component.ts